import { generatePaymentIntentApiCall, generateWidgetPaymentIntentApiCall } from '@guryou/api-client-gql';
import { execute } from './actionWrapper';
import { PAYMENT_INTENT_GET } from '../types';
const generatePaymentIntent = _ref => {
  let {
    reservationId,
    subscriptionId,
    productId,
    membershipId,
    email,
    firstname,
    lastname,
    phone
  } = _ref;
  return async dispatch => execute(dispatch, () => generatePaymentIntentApiCall({
    reservationId,
    subscriptionId,
    productId,
    membershipId,
    email,
    firstname: firstname || null,
    lastname: lastname || null,
    phone: phone || null
  }), PAYMENT_INTENT_GET, true);
};
const generateWidgetPaymentIntent = _ref2 => {
  let {
    reservationId,
    subscriptionId,
    productId,
    membershipId,
    email,
    firstname,
    lastname,
    phone
  } = _ref2;
  return async dispatch => execute(dispatch, () => generateWidgetPaymentIntentApiCall({
    reservationId,
    subscriptionId,
    productId,
    membershipId,
    email,
    firstname: firstname || null,
    lastname: lastname || null,
    phone: phone || null
  }), PAYMENT_INTENT_GET, true);
};
export { generatePaymentIntent, generateWidgetPaymentIntent };